import { Action } from 'acscp/actions';

/**
 * Fired whenever the app is either first loaded or resumed. Not fired on the web.
 */
export class AppResumed extends Action {}
